module.exports = __webpack_public_path__ + "img/monster-gray-2.a8343dfb.png";